import * as grid from 'view/styles/grid';

export const footerPadding = grid.multiple(6).unitless;
export const footerJsdIconHeight = grid.multiple(2.5).unitless;
export const FOOTER_HEIGHT = footerPadding * 2 + footerJsdIconHeight;
